export const GET_ACCOUNT = 'GET_ACCOUNT';

export const GET_ARTICLE = 'GET_ARTICLE';
export const GET_ARTICLE_EDITING = 'GET_ARTICLE_EDITING';
export const GET_ARTICLES = 'GET_ARTICLES';

export const GET_APP_PAGES = 'GET_APP_PAGES';
export const GET_APP_SNACKBAR = 'GET_APP_SNACKBAR';
export const GET_APP_TOAST = 'GET_APP_TOAST';

export const GET_BELIEF_STATEMENT = 'GET_BELIEF_STATEMENT';
export const GET_BELIEF_STATEMENTS = 'GET_BELIEF_STATEMENTS';

export const GET_CHANNEL = 'GET_CHANNEL';
export const GET_CHANNELS = 'GET_CHANNELS';

export const GET_COLLECTION = 'GET_COLLECTION';
export const GET_COLLECTION_FILTERS = 'GET_COLLECTION_FILTERS';
export const GET_COLLECTIONS = 'GET_COLLECTIONS';

export const GET_IS_AUTHENTICATED = 'GET_IS_AUTHENTICATED';
export const GET_PAYLOAD = 'GET_PAYLOAD';

export const GET_EPISODE = 'GET_EPISODE';
export const GET_EPISODE_FILTERS = 'GET_EPISODE_FILTERS';
export const GET_EPISODES = 'GET_EPISODES';

export const GET_EVENT = 'GET_EVENT';
export const GET_EVENT_FILTERS = 'GET_EVENT_FILTERS';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_REFRESH = 'GET_EVENTS_REFRESH';
export const GET_EVENTS_TAGS = 'GET_EVENTS_TAGS';

export const GET_EVENT_CONTACT = 'GET_EVENT_CONTACT';

export const GET_EVENT_REGISTRATION = 'GET_EVENT_REGISTRATION';
export const GET_EVENT_REGISTRATION_REFRESH = 'GET_EVENT_REGISTRATION_REFRESH';
export const GET_EVENT_REGISTRATIONS = 'GET_EVENT_REGISTRATIONS';

export const GET_FORM = 'GET_FORM';
export const GET_FORM_SAVING = 'GET_FORM_SAVING';
export const GET_FORM_REFRESH = 'GET_FORM_REFRESH';

export const GET_FORM_FIELD = 'GET_FORM_FIELD';

export const GET_LOCATIONS = 'GET_LOCATIONS';

export const GET_MEDIA_FILTERS = 'GET_MEDIA_FILTERS';
export const GET_MEDIA_TAB = 'GET_MEDIA_TAB';
export const GET_MEDIA_TAGS = 'GET_MEDIA_TAGS';
export const GET_MEDIA_REFRESH = 'GET_MEDIA_REFRESH';

export const GET_MEMBER = 'GET_MEMBER';
export const GET_MEMBERS = 'GET_MEMBERS';

export const GET_MINISTRY = 'GET_MINISTRY';
export const GET_MINISTRY_FILTERS = 'GET_MINISTRY_FILTERS';
export const GET_MINISTRY_MODE = 'GET_MINISTRY_MODE';
export const GET_MINISTRY_REFRESH = 'GET_MINISTRY_REFRESH';
export const GET_MINISTRIES = 'GET_MINISTRIES';

export const GET_MINISTRY_ROLE = 'GET_MINISTRY_ROLE';

export const GET_ORDER = 'GET_ORDER';

export const GET_PAGE = 'GET_PAGE';
export const GET_PAGES = 'GET_PAGES';

export const GET_SERVICE = 'GET_SERVICE';
export const GET_SERVICES = 'GET_SERVICES';

export const GET_STAFF_MEMBER = 'GET_STAFF_MEMBER';
export const GET_STAFF_MEMBERS = 'GET_STAFF_MEMBERS';

export const GET_SPEAKER = 'GET_SPEAKER';
export const GET_SPEAKER_FILTERS = 'GET_SPEAKER_FILTERS';
export const GET_SPEAKERS = 'GET_SPEAKERS';

export const GET_TAG = 'GET_TAG';

export const GET_USER = 'GET_USER';
export const GET_AUTHENTICATED_USER = 'GET_AUTHENTICATED_USER';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_REFRESH = 'GET_USERS_REFRESH';

export const GET_WAIVER = 'GET_WAIVER';
export const GET_WAIVERS = 'GET_WAIVERS';



// WEBPACK FOOTER //
// ./src/store/types/getters.js